<template>
	<div>
		<vue-snotify></vue-snotify>
		<session-timeout/>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'vuex';
	import SessionTimeout from './SessionTimeout.vue';

	export default {
		name: 'Global',
		components: {
			SessionTimeout,
		},
	}
</script>
